const elements = document.querySelectorAll('.wpcf7-form-control-wrap');

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('active');
          } else {
            entry.target.classList.remove('active');
          }
    });
  },
  {
    threshold: 0.2 // 20% елемента видно
  }
);

elements.forEach((el) => observer.observe(el));

